const actions = {
  SET_STATE: 'webhooks/SET_STATE',
  TRIGGERS_LIST: 'webhooks/TRIGGERS_LIST',
  TRIGGERS_LIST_NEW: 'webhooks/TRIGGERS_LIST_NEW',
  WEBHOOKS_LIST: 'webhooks/WEBHOOKS_LIST',
  WEBHOOKS_LIST_NEW: 'webhooks/WEBHOOKS_LIST_NEW',
  GET_WEBHOOK: 'webhooks/GET_WEBHOOK',
  GET_WEBHOOK_NEW: 'webhooks/GET_WEBHOOK_NEW',
  ADD_WEBHOOK: 'webhooks/ADD_WEBHOOK',
  ADD_WEBHOOK_NEW: 'webhooks/ADD_WEBHOOK_NEW',
  UPDATE_WEBHOOK: 'webhooks/UPDATE_WEBHOOK',
  UPDATE_WEBHOOK_NEW: 'webhooks/UPDATE_WEBHOOK_NEW',
  DELETE_WEBHOOK: 'webhooks/DELETE_WEBHOOK',
  DELETE_WEBHOOK_NEW: 'webhooks/DELETE_WEBHOOK_NEW',
  CHANGE_WEBHOOK_STATUS: 'webhooks/CHANGE_WEBHOOK_STATUS',
  CHANGE_WEBHOOK_STATUS_NEW: 'webhooks/CHANGE_WEBHOOK_STATUS_NEW',
}

export default actions
